import { Link, withRouter } from 'react-router-dom';
import WithScroll from 'hocs/WithScroll';
import { ROOT } from '../../../../../constants';

const CategoryListItem = ({
  id,
  name,
  articles,
  match,
  onClick,
  onLinkClick,
  isOpen,
  scroll,
}) => {
  const handleClick = () => onClick(id);

  const handleLinkClick = () => {
    onLinkClick();
    scroll.triggerScrolling();
  };

  return (
    <li className="search-nav__category-item" onClick={handleClick}>
      <a className="search-nav__category-link">{name}</a>
      {isOpen && (
        <ul className="search-nav__subcategory-list">
          {articles.map((article, index) => (
            <li className="search-nav__subcategory-item" key={index}>
              <Link
                to={`${ROOT}/${match.params.collectionSlug}/${article.slug}`}
                className={cx('search-nav__subcategory-link', {
                  'search-nav__subcategory-link_active':
                    article.slug === match.params.articleSlug,
                })}
                onClick={handleLinkClick}
              >
                {article.name}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

export default withRouter(WithScroll(CategoryListItem));
